// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { getAllBusesReport, getBusReport } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/BusReport.css';
// import { toast } from 'react-toastify';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Bus Details</th>
//           <th>Registration</th>
//           <th>Type</th>
//           <th>Route</th>
//           <th>Seat Booking</th>
//           <th>Instant Booking</th>
//           <th>Razorpay</th>
//           <th>TDS</th>
//           <th>HDFC</th>
//           <th>Penalty</th>
//           <th>Refund</th>
//           <th>Payable Amount</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const BusReport = () => {
//   const { token } = useSelector(state => state.user);
  
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedBus, setSelectedBus] = useState(null);
//   const [viewingReport, setViewingReport] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   const [dateRange, setDateRange] = useState({
//     startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)
//       .toISOString().split('T')[0],
//     endDate: new Date().toISOString().split('T')[0]
//   });

//   const [filterOwner, setFilterOwner] = useState('');

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalReports, setTotalReports] = useState(0);
//   const [pageSize] = useState(10);

//   const [stats, setStats] = useState({
//     totalBuses: 0,
//     totalSeatBooking: 0,
//     totalInstantBooking: 0,
//     totalPayable: 0,
//     totalPenalty: 0,
//     totalRefund: 0,
//     acBuses: 0,
//     nonAcBuses: 0
//   });

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   const fetchReports = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const response = await getAllBusesReport(
//         token,
//         dateRange.startDate,
//         dateRange.endDate,
//         filterOwner || undefined
//       );

//       if (response && response.success) {
//         const transformedReports = response.data.map((report, index) => ({
//           id: index,
//           serialNo: getSequentialNumber(index),
//           busDetails: report['Bus Details'] || '',
//           busRegistration: report['Bus Registration'] || '',
//           busType: report['Bus Type'] || '',
//           route: report['Route'] || '',
//           seatBooking: report['Seat Booking'] || 0,
//           instantBooking: report['Intant Booking'] || 0,
//           razorpay: report['Razorpay(Deduction)'] || 0,
//           tds: report['TDS(Deduction)'] || 0,
//           hdfc: report['HDFC Deduction'] || 0,
//           penalty: report['Penaulty to Customer'] || 0,
//           cgst: report['CGST'] || 0,
//           sgst: report['SGST'] || 0,
//           igst: report['IGST'] || 0,
//           refund: report['Refund to Customer'] || 0,
//           payableAmount: report['Payable Amount'] || 0,
//           formula: report._formula || {},
//           meta: report._meta || { seatBookingCount: 0, instantBookingCount: 0 }
//         }));

//         setReports(transformedReports);
//         setTotalReports(response.count || 0);
//         setTotalPages(Math.ceil((response.count || 0) / pageSize));

//         calculateStats(transformedReports);
//       } else {
//         setReports([]);
//         setTotalReports(0);
//         setTotalPages(1);
//         setStats({
//           totalBuses: 0,
//           totalSeatBooking: 0,
//           totalInstantBooking: 0,
//           totalPayable: 0,
//           totalPenalty: 0,
//           totalRefund: 0,
//           acBuses: 0,
//           nonAcBuses: 0
//         });
//       }
//     } catch (err) {
//       console.error('Error fetching bus reports:', err);
//       setError('Failed to fetch bus reports. Please try again.');
//       toast.error('Failed to fetch bus reports');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateStats = (data) => {
//     const totalSeatBooking = data.reduce((sum, item) => sum + item.seatBooking, 0);
//     const totalInstantBooking = data.reduce((sum, item) => sum + item.instantBooking, 0);
//     const totalPayable = data.reduce((sum, item) => sum + item.payableAmount, 0);
//     const totalPenalty = data.reduce((sum, item) => sum + item.penalty, 0);
//     const totalRefund = data.reduce((sum, item) => sum + item.refund, 0);
//     const acBuses = data.filter(item => item.busType === 'AC').length;
//     const nonAcBuses = data.filter(item => item.busType === 'NON-AC').length;

//     setStats({
//       totalBuses: data.length,
//       totalSeatBooking,
//       totalInstantBooking,
//       totalPayable,
//       totalPenalty,
//       totalRefund,
//       acBuses,
//       nonAcBuses
//     });
//   };

//   const handleViewReport = async (busRegistration) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);

//       const bus = reports.find(r => r.busRegistration === busRegistration);
//       if (!bus) {
//         throw new Error('Bus not found');
//       }

//       setViewingReport(bus);
//     } catch (err) {
//       console.error('Error fetching bus report details:', err);
//       setError('Failed to fetch bus report details.');
//       toast.error('Failed to fetch bus report details');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const closeViewModal = () => {
//     setViewingReport(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleFilterOwnerChange = (e) => {
//     setFilterOwner(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     fetchReports();
//   };

//   const handleExportCSV = () => {
//     if (filteredReports.length === 0) {
//       toast.warning('No data to export');
//       return;
//     }

//     const headers = [
//       'Serial No.',
//       'Bus Details',
//       'Registration',
//       'Type',
//       'Route',
//       'Seat Booking',
//       'Instant Booking',
//       'Razorpay',
//       'TDS',
//       'HDFC',
//       'Penalty',
//       'CGST',
//       'SGST',
//       'IGST',
//       'Refund',
//       'Payable Amount'
//     ];

//     const csvData = filteredReports.map(report => [
//       report.serialNo,
//       `"${report.busDetails || ''}"`,
//       `"${report.busRegistration || ''}"`,
//       `"${report.busType || ''}"`,
//       `"${report.route || ''}"`,
//       report.seatBooking.toFixed(2),
//       report.instantBooking.toFixed(2),
//       report.razorpay.toFixed(2),
//       report.tds.toFixed(2),
//       report.hdfc.toFixed(2),
//       report.penalty.toFixed(2),
//       report.cgst.toFixed(2),
//       report.sgst.toFixed(2),
//       report.igst.toFixed(2),
//       report.refund.toFixed(2),
//       report.payableAmount.toFixed(2)
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `bus-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     toast.success('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const filteredReports = reports.filter(report =>
//     (report.busDetails && report.busDetails.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (report.busRegistration && report.busRegistration.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (report.route && report.route.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (report.busType && report.busType.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   useEffect(() => {
//     fetchReports();
//   }, [dateRange.startDate, dateRange.endDate, filterOwner]);

//   if (loading && reports.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page bus-report-page">
//       <div className="page-header">
//         <h1>Bus Report</h1>
//         <div className="header-actions">
//           <div className="filters-group">
//             <div className="date-filters">
//               <label>
//                 Start Date:
//                 <input
//                   type="date"
//                   name="startDate"
//                   value={dateRange.startDate}
//                   onChange={handleDateChange}
//                   className="date-input"
//                 />
//               </label>
//               <label>
//                 End Date:
//                 <input
//                   type="date"
//                   name="endDate"
//                   value={dateRange.endDate}
//                   onChange={handleDateChange}
//                   className="date-input"
//                 />
//               </label>
//             </div>
//             <input
//               type="text"
//               placeholder="Search buses by name, registration or route..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "250px" }}
//             />
//           </div>

//           <button className="refresh-btn" onClick={handleRefresh}>
//             🔄 Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             📊 Export CSV
//           </button>
//         </div>
//       </div>

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         Total Reports: {totalReports} | Page {currentPage} of {totalPages} | 
//         Date Range: {dateRange.startDate} to {dateRange.endDate}
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}


//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Buses</h3>
//           <p>{stats.totalBuses}</p>
//           <span>Buses in report</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Seat Booking</h3>
//           <p>₹{stats.totalSeatBooking.toFixed(2)}</p>
//           <span>Total seat bookings</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Instant Booking</h3>
//           <p>₹{stats.totalInstantBooking.toFixed(2)}</p>
//           <span>Total instant bookings</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Payable</h3>
//           <p>₹{stats.totalPayable.toFixed(2)}</p>
//           <span>Total payable amount</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Penalty</h3>
//           <p>₹{stats.totalPenalty.toFixed(2)}</p>
//           <span>Total penalty amount</span>
//         </div>
//         <div className="stat-card">
//           <h3>Total Refund</h3>
//           <p>₹{stats.totalRefund.toFixed(2)}</p>
//           <span>Total refund amount</span>
//         </div>
//         <div className="stat-card">
//           <h3>AC Buses</h3>
//           <p>{stats.acBuses}</p>
//           <span>AC buses</span>
//         </div>
//         <div className="stat-card">
//           <h3>NON-AC Buses</h3>
//           <p>{stats.nonAcBuses}</p>
//           <span>NON-AC buses</span>
//         </div>
//       </div>


//       <div className="table-container" style={{ overflowX: 'auto' }}>
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Bus Details</th>
//               <th>Registration</th>
//               <th>Type</th>
//               <th>Route</th>
//               <th>Seat Booking</th>
//               <th>Instant Booking</th>
//               <th>Razorpay</th>
//               <th>TDS</th>
//               <th>HDFC</th>
//               <th>Penalty</th>
//               <th>Refund</th>
//               <th>Payable</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredReports.length > 0 ? (
//               filteredReports.map(report => (
//                 <tr key={report.id}>
//                   <td>{report.serialNo}</td>
//                   <td>
//                     <strong>{report.busDetails}</strong>
//                     {report.meta && report.meta.seatBookingCount > 0 && (
//                       <div className="booking-count">
//                         <small>{report.meta.seatBookingCount} seat bookings</small>
//                       </div>
//                     )}
//                   </td>
//                   <td>{report.busRegistration}</td>
//                   <td>
//                     <span className={`bus-type-badge ${report.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                       {report.busType}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="route-info" title={report.route}>
//                       {report.route.length > 30 ? 
//                         `${report.route.substring(0, 30)}...` : 
//                         report.route}
//                     </div>
//                   </td>
//                   <td>₹{report.seatBooking.toFixed(2)}</td>
//                   <td>₹{report.instantBooking.toFixed(2)}</td>
//                   <td>₹{report.razorpay.toFixed(2)}</td>
//                   <td>₹{report.tds.toFixed(2)}</td>
//                   <td>₹{report.hdfc.toFixed(2)}</td>
//                   <td>
//                     <span className={`penalty-amount ${report.penalty > 0 ? 'has-penalty' : ''}`}>
//                       ₹{report.penalty.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <span className={`refund-amount ${report.refund > 0 ? 'has-refund' : ''}`}>
//                       ₹{report.refund.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <span className="payable-amount">
//                       ₹{report.payableAmount.toFixed(2)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewReport(report.busRegistration)}
//                       >
//                         View Details
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="14" className="no-data">
//                   <p>
//                     {searchTerm 
//                       ? 'No buses found matching your search.' 
//                       : 'No bus reports available for the selected date range.'}
//                   </p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={() => setSearchTerm('')}>
//                       Clear search to see all buses
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>


//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {filteredReports.length} of {totalReports} buses
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>


//       {viewingReport && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1 bus-report-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Bus Report Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="report-details">
//                 <div className="report-header">
//                   <h2>{viewingReport.busDetails}</h2>
//                   <p className="registration">{viewingReport.busRegistration}</p>
//                   <span className={`bus-type-badge ${viewingReport.busType === 'AC' ? 'ac' : 'non-ac'}`}>
//                     {viewingReport.busType}
//                   </span>
//                 </div>

//                 <div className="report-section">
//                   <h4>Route Information</h4>
//                   <div className="detail-row">
//                     <label>Route:</label>
//                     <span>{viewingReport.route}</span>
//                   </div>
//                 </div>

//                 <div className="report-section">
//                   <h4>Booking Summary</h4>
//                   <div className="detail-grid">
//                     <div className="detail-item">
//                       <label>Seat Booking:</label>
//                       <span className="amount">₹{viewingReport.seatBooking.toFixed(2)}</span>
//                       <small>{viewingReport.meta?.seatBookingCount || 0} bookings</small>
//                     </div>
//                     <div className="detail-item">
//                       <label>Instant Booking:</label>
//                       <span className="amount">₹{viewingReport.instantBooking.toFixed(2)}</span>
//                       <small>{viewingReport.meta?.instantBookingCount || 0} bookings</small>
//                     </div>
//                     <div className="detail-item">
//                       <label>Total Gross:</label>
//                       <span className="amount">
//                         ₹{(viewingReport.seatBooking + viewingReport.instantBooking).toFixed(2)}
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="report-section">
//                   <h4>Deductions</h4>
//                   <div className="detail-grid">
//                     <div className="detail-item">
//                       <label>Razorpay:</label>
//                       <span className="amount deduction">₹{viewingReport.razorpay.toFixed(2)}</span>
//                       {viewingReport.formula?.razorpay && (
//                         <small>{viewingReport.formula.razorpay}</small>
//                       )}
//                     </div>
//                     <div className="detail-item">
//                       <label>TDS:</label>
//                       <span className="amount deduction">₹{viewingReport.tds.toFixed(2)}</span>
//                       {viewingReport.formula?.tds && (
//                         <small>{viewingReport.formula.tds}</small>
//                       )}
//                     </div>
//                     <div className="detail-item">
//                       <label>HDFC:</label>
//                       <span className="amount deduction">₹{viewingReport.hdfc.toFixed(2)}</span>
//                       {viewingReport.formula?.hdfc && (
//                         <small>{viewingReport.formula.hdfc}</small>
//                       )}
//                     </div>
//                     <div className="detail-item">
//                       <label>Penalty:</label>
//                       <span className={`amount ${viewingReport.penalty > 0 ? 'deduction' : ''}`}>
//                         ₹{viewingReport.penalty.toFixed(2)}
//                       </span>
//                       {viewingReport.formula?.penalty && (
//                         <small>{viewingReport.formula.penalty}</small>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {viewingReport.cgst > 0 || viewingReport.sgst > 0 || viewingReport.igst > 0 && (
//                   <div className="report-section">
//                     <h4>Tax Summary</h4>
//                     <div className="detail-grid">
//                       {viewingReport.cgst > 0 && (
//                         <div className="detail-item">
//                           <label>CGST:</label>
//                           <span className="amount tax">₹{viewingReport.cgst.toFixed(2)}</span>
//                         </div>
//                       )}
//                       {viewingReport.sgst > 0 && (
//                         <div className="detail-item">
//                           <label>SGST:</label>
//                           <span className="amount tax">₹{viewingReport.sgst.toFixed(2)}</span>
//                         </div>
//                       )}
//                       {viewingReport.igst > 0 && (
//                         <div className="detail-item">
//                           <label>IGST:</label>
//                           <span className="amount tax">₹{viewingReport.igst.toFixed(2)}</span>
//                         </div>
//                       )}
//                       {viewingReport.formula?.gst && (
//                         <div className="detail-item full-width">
//                           <small>{viewingReport.formula.gst}</small>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}

//                 <div className="report-section">
//                   <h4>Refund Information</h4>
//                   <div className="detail-row">
//                     <label>Refund to Customer:</label>
//                     <span className={`amount ${viewingReport.refund > 0 ? 'refund' : ''}`}>
//                       ₹{viewingReport.refund.toFixed(2)}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="report-section total-section">
//                   <div className="detail-row total">
//                     <label>Payable Amount:</label>
//                     <span className="total-amount">₹{viewingReport.payableAmount.toFixed(2)}</span>
//                   </div>
//                   {viewingReport.formula?.payable && (
//                     <div className="formula-breakdown">
//                       <small>{viewingReport.formula.payable}</small>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingReport && isFetchingDetails && (
//         <div className="modal-overlay">
//           <div className="modal-content1 skeleton-modal">
//             <div className="modal-header">
//               <div className="skeleton-title"></div>
//               <div className="skeleton-close"></div>
//             </div>
//             <div className="modal-body">
//               <div className="skeleton-profile-image"></div>
//               {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//                 <div key={i} className="skeleton-detail-row">
//                   <div className="skeleton-label"></div>
//                   <div className="skeleton-value"></div>
//                 </div>
//               ))}
//             </div>
//             <div className="modal-footer">
//               <div className="skeleton-button"></div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BusReport;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getAllBusesReport } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/BusReport.css';            // bus-report-only additions (load LAST)
import { toast } from 'react-toastify';
import { Icon, BusSvg, StatCard, Avatar, Pagination, Field } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const fmtINR = (v) => `₹${Number(v || 0).toFixed(2)}`;

// ============================================================
// MAIN
// ============================================================
const BusReport = () => {
  const { token } = useSelector(state => state.user);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBus, setSelectedBus] = useState(null);
  const [viewingReport, setViewingReport] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [layout, setLayout] = useState('table');

  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1)
      .toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });

  const [filterOwner, setFilterOwner] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [stats, setStats] = useState({
    totalBuses: 0, totalSeatBooking: 0, totalInstantBooking: 0, totalPayable: 0,
    totalPenalty: 0, totalRefund: 0, acBuses: 0, nonAcBuses: 0
  });

  const getSequentialNumber = (index) => (currentPage - 1) * pageSize + index + 1;

  const fetchReports = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAllBusesReport(
        token, dateRange.startDate, dateRange.endDate, filterOwner || undefined
      );
      if (response && response.success) {
        const transformedReports = response.data.map((report, index) => ({
          id: index,
          serialNo: getSequentialNumber(index),
          busDetails: report['Bus Details'] || '',
          busRegistration: report['Bus Registration'] || '',
          busType: report['Bus Type'] || '',
          route: report['Route'] || '',
          seatBooking: report['Seat Booking'] || 0,
          instantBooking: report['Intant Booking'] || 0,
          razorpay: report['Razorpay(Deduction)'] || 0,
          tds: report['TDS(Deduction)'] || 0,
          hdfc: report['HDFC Deduction'] || 0,
          penalty: report['Penaulty to Customer'] || 0,
          cgst: report['CGST'] || 0,
          sgst: report['SGST'] || 0,
          igst: report['IGST'] || 0,
          refund: report['Refund to Customer'] || 0,
          payableAmount: report['Payable Amount'] || 0,
          formula: report._formula || {},
          meta: report._meta || { seatBookingCount: 0, instantBookingCount: 0 }
        }));
        setReports(transformedReports);
        setTotalReports(response.count || 0);
        setTotalPages(Math.ceil((response.count || 0) / pageSize));
        calculateStats(transformedReports);
      } else {
        setReports([]); setTotalReports(0); setTotalPages(1);
        setStats({ totalBuses: 0, totalSeatBooking: 0, totalInstantBooking: 0, totalPayable: 0, totalPenalty: 0, totalRefund: 0, acBuses: 0, nonAcBuses: 0 });
      }
    } catch (err) {
      console.error('Error fetching bus reports:', err);
      setError('Failed to fetch bus reports. Please try again.');
      toast.error('Failed to fetch bus reports');
    } finally {
      setLoading(false); setFirstLoad(false);
    }
  };

  const calculateStats = (data) => {
    const totalSeatBooking = data.reduce((sum, item) => sum + item.seatBooking, 0);
    const totalInstantBooking = data.reduce((sum, item) => sum + item.instantBooking, 0);
    const totalPayable = data.reduce((sum, item) => sum + item.payableAmount, 0);
    const totalPenalty = data.reduce((sum, item) => sum + item.penalty, 0);
    const totalRefund = data.reduce((sum, item) => sum + item.refund, 0);
    const acBuses = data.filter(item => item.busType === 'AC').length;
    const nonAcBuses = data.filter(item => item.busType === 'NON-AC').length;
    setStats({ totalBuses: data.length, totalSeatBooking, totalInstantBooking, totalPayable, totalPenalty, totalRefund, acBuses, nonAcBuses });
  };

  const handleViewReport = async (busRegistration) => {
    try {
      setIsFetchingDetails(true); setError(null);
      const bus = reports.find(r => r.busRegistration === busRegistration);
      if (!bus) throw new Error('Bus not found');
      setViewingReport(bus);
    } catch (err) {
      console.error('Error fetching bus report details:', err);
      setError('Failed to fetch bus report details.');
      toast.error('Failed to fetch bus report details');
    } finally { setIsFetchingDetails(false); }
  };

  const closeViewModal = () => setViewingReport(null);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prev => ({ ...prev, [name]: value }));
  };

  const handleFilterOwnerChange = (e) => { setFilterOwner(e.target.value); setCurrentPage(1); };

  const handleRefresh = () => { fetchReports(); };

  const handleExportCSV = () => {
    if (filteredReports.length === 0) { toast.warning('No data to export'); return; }
    const headers = ['Serial No.', 'Bus Details', 'Registration', 'Type', 'Route', 'Seat Booking', 'Instant Booking', 'Razorpay', 'TDS', 'HDFC', 'Penalty', 'CGST', 'SGST', 'IGST', 'Refund', 'Payable Amount'];
    const csvData = filteredReports.map(report => [
      report.serialNo, `"${report.busDetails || ''}"`, `"${report.busRegistration || ''}"`, `"${report.busType || ''}"`, `"${report.route || ''}"`,
      report.seatBooking.toFixed(2), report.instantBooking.toFixed(2), report.razorpay.toFixed(2), report.tds.toFixed(2), report.hdfc.toFixed(2),
      report.penalty.toFixed(2), report.cgst.toFixed(2), report.sgst.toFixed(2), report.igst.toFixed(2), report.refund.toFixed(2), report.payableAmount.toFixed(2)
    ]);
    const csvContent = [headers.join(','), ...csvData.map(row => row.join(','))].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `bus-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully!');
  };

  const filteredReports = reports.filter(report =>
    (report.busDetails && report.busDetails.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (report.busRegistration && report.busRegistration.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (report.route && report.route.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (report.busType && report.busType.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Keep currentPage bounded
  useEffect(() => { if (currentPage > totalPages && totalPages >= 1) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  useEffect(() => { fetchReports(); /* eslint-disable-next-line */ }, [dateRange.startDate, dateRange.endDate, filterOwner]);

  // ============================================================
  if (firstLoad && loading && reports.length === 0) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="bus" size={13} /> Reports</span>
          <h1>Bus Report</h1><p>Loading bus reports…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="bus" size={13} /> Financial Insights</span>
          <h1>Bus Report</h1>
          <p>Financial breakdown of seat bookings, instant bookings, deductions and payouts per bus.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by name, registration or route…" value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleExportCSV}>
            <span className="plus"><Icon name="download" size={14} /></span> Export CSV
          </button>
        </div>
      </div>

      {error && <div className="br-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={handleRefresh}>Retry</button></div>}

      {/* DATE FILTER STRIP */}
      <div className="br-filter-strip">
        <Field label="Start Date">
          <input type="date" name="startDate" value={dateRange.startDate} onChange={handleDateChange} className="prm-input" />
        </Field>
        <Field label="End Date">
          <input type="date" name="endDate" value={dateRange.endDate} onChange={handleDateChange} className="prm-input" />
        </Field>
        <div className="br-filter-info">
          <Icon name="calendar" size={14} /> {totalReports} reports · {formatDateDMY(dateRange.startDate)} → {formatDateDMY(dateRange.endDate)}
        </div>
      </div>

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="bus" tone="indigo" label="Total Buses" value={stats.totalBuses} hint="Buses in report" delay={80} />
        <StatCard icon="check" tone="green" label="Seat Bookings" value={fmtINR(stats.totalSeatBooking)} hint="Total seat booking amount" delay={140} />
        <StatCard icon="ticket" tone="amber" label="Instant Bookings" value={fmtINR(stats.totalInstantBooking)} hint="Total instant booking amount" delay={200} />
        <StatCard icon="wallet" tone="cyan" label="Payable Amount" value={fmtINR(stats.totalPayable)} hint="Net payable to owners" delay={260} />
        <StatCard icon="info" tone="red" label="Penalty" value={fmtINR(stats.totalPenalty)} hint="Penalty to customers" delay={320} />
        <StatCard icon="refresh" tone="indigo" label="Refund" value={fmtINR(stats.totalRefund)} hint="Refunded to customers" delay={380} />
        <StatCard icon="bus" tone="green" label="AC Buses" value={stats.acBuses} hint="AC fleet" delay={440} />
        <StatCard icon="bus" tone="amber" label="Non-AC Buses" value={stats.nonAcBuses} hint="Non-AC fleet" delay={500} />
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button className={`prm-chip ${layout === 'table' ? 'active' : ''}`} onClick={() => setLayout('table')}>Table</button>
            <button className={`prm-chip ${layout === 'cards' ? 'active' : ''}`} onClick={() => setLayout('cards')}>Cards</button>
          </div>
          {searchTerm && <span className="prm-tag amber">Search: "{searchTerm}"</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{filteredReports.length}</b> of {totalReports}</span>
        </div>
      </div>

      {/* LIST */}
      <div className={loading ? 'br-loading' : ''}>
        {filteredReports.length === 0 ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm ? 'search' : 'bus'} size={44} /></div>
            <h3>{searchTerm ? 'No buses match your search' : 'No bus reports available'}</h3>
            <p>{searchTerm ? 'Try a different search term or clear the search.' : 'No reports found for the selected date range.'}</p>
            {searchTerm && <button className="prm-btn ghost" onClick={() => setSearchTerm('')}>Clear search</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {filteredReports.map((report, i) => (
              <div key={report.id} className="prm-card br-card" style={{ animationDelay: `${i * 60}ms` }}>
                <div className="prm-card-top">
                  <div className="pbo-owner-id">
                    <Avatar name={report.busDetails} size={52} />
                    <div>
                      <div className="prm-card-no">Bus #{String(report.serialNo).padStart(2, '0')}</div>
                      <h3 className="prm-card-title">{report.busDetails || 'N/A'}</h3>
                      <div className="prm-card-sub"><Icon name="bus" size={14} /> {report.busRegistration || 'N/A'}</div>
                    </div>
                  </div>
                  <span className={`prm-status ${report.busType === 'AC' ? 'active' : 'inactive'}`}>{report.busType}</span>
                </div>
                <div className="pbo-contact">
                  <div><Icon name="grid" size={14} /> {report.route || 'N/A'}</div>
                </div>
                <div className="br-metrics-grid">
                  <div><small>Seat</small><b className="br-pos">{fmtINR(report.seatBooking)}</b></div>
                  <div><small>Instant</small><b className="br-pos">{fmtINR(report.instantBooking)}</b></div>
                  <div><small>Razorpay</small><b className="br-neg">{fmtINR(report.razorpay)}</b></div>
                  <div><small>TDS</small><b className="br-neg">{fmtINR(report.tds)}</b></div>
                  <div><small>HDFC</small><b className="br-neg">{fmtINR(report.hdfc)}</b></div>
                  <div><small>Penalty</small><b className={report.penalty > 0 ? 'br-neg' : ''}>{fmtINR(report.penalty)}</b></div>
                  <div><small>Refund</small><b className={report.refund > 0 ? 'br-neg' : ''}>{fmtINR(report.refund)}</b></div>
                  <div><small>Payable</small><b className="br-total">{fmtINR(report.payableAmount)}</b></div>
                </div>
                <div className="pbo-card-actions">
                  <button className="prm-btn view sm" onClick={() => handleViewReport(report.busRegistration)}>
                    <Icon name="eye" size={14} /> View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>No.</th><th>Bus</th><th>Type</th><th>Route</th>
                  <th>Seat</th><th>Instant</th><th>Razorpay</th><th>TDS</th>
                  <th>HDFC</th><th>Penalty</th><th>Refund</th><th>Payable</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredReports.map((report, i) => (
                  <tr key={report.id} style={{ animationDelay: `${i * 40}ms` }}>
                    <td>{report.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={report.busDetails} size={38} />
                        <div>
                          <div className="name">{report.busDetails || 'N/A'}</div>
                          <div className="sub">{report.busRegistration || 'N/A'}</div>
                        </div>
                      </div>
                    </td>
                    <td><span className={`prm-status ${report.busType === 'AC' ? 'active' : 'inactive'}`}>{report.busType}</span></td>
                    <td>
                      <div title={report.route} style={{ maxWidth: 220 }}>
                        {report.route.length > 30 ? `${report.route.substring(0, 30)}...` : report.route}
                      </div>
                    </td>
                    <td><span className="br-pos">{fmtINR(report.seatBooking)}</span></td>
                    <td><span className="br-pos">{fmtINR(report.instantBooking)}</span></td>
                    <td><span className="br-neg">{fmtINR(report.razorpay)}</span></td>
                    <td><span className="br-neg">{fmtINR(report.tds)}</span></td>
                    <td><span className="br-neg">{fmtINR(report.hdfc)}</span></td>
                    <td><span className={report.penalty > 0 ? 'br-neg' : ''}>{fmtINR(report.penalty)}</span></td>
                    <td><span className={report.refund > 0 ? 'br-neg' : ''}>{fmtINR(report.refund)}</span></td>
                    <td><span className="br-total">{fmtINR(report.payableAmount)}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewReport(report.busRegistration)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalReports}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="reports"
      />

      {/* VIEW MODAL */}
      {viewingReport && !isFetchingDetails && (
        <div className="prm-overlay" onClick={closeViewModal}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingReport.busDetails} size={52} />
                <div>
                  <h3>{viewingReport.busDetails}</h3>
                  <p>{viewingReport.busRegistration} · {viewingReport.busType}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={closeViewModal}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Seat Booking</span><b className="br-pos">{fmtINR(viewingReport.seatBooking)}</b></div>
                <div><span>Instant</span><b className="br-pos">{fmtINR(viewingReport.instantBooking)}</b></div>
                <div><span>Total Gross</span><b className="br-total">{fmtINR(viewingReport.seatBooking + viewingReport.instantBooking)}</b></div>
                <div><span>Payable</span><b className="br-total">{fmtINR(viewingReport.payableAmount)}</b></div>
              </div>

              <div className="prm-section-title">Route</div>
              <div className="br-detail-grid">
                <div><small>Route</small><b>{viewingReport.route || 'N/A'}</b></div>
              </div>

              <div className="prm-section-title">Booking summary</div>
              <div className="br-detail-grid">
                <div><small>Seat Booking</small><b className="br-pos">{fmtINR(viewingReport.seatBooking)}</b><span>{viewingReport.meta?.seatBookingCount || 0} bookings</span></div>
                <div><small>Instant Booking</small><b className="br-pos">{fmtINR(viewingReport.instantBooking)}</b><span>{viewingReport.meta?.instantBookingCount || 0} bookings</span></div>
              </div>

              <div className="prm-section-title">Deductions</div>
              <div className="br-detail-grid">
                <div><small>Razorpay</small><b className="br-neg">{fmtINR(viewingReport.razorpay)}</b>{viewingReport.formula?.razorpay && <span>{viewingReport.formula.razorpay}</span>}</div>
                <div><small>TDS</small><b className="br-neg">{fmtINR(viewingReport.tds)}</b>{viewingReport.formula?.tds && <span>{viewingReport.formula.tds}</span>}</div>
                <div><small>HDFC</small><b className="br-neg">{fmtINR(viewingReport.hdfc)}</b>{viewingReport.formula?.hdfc && <span>{viewingReport.formula.hdfc}</span>}</div>
                <div><small>Penalty</small><b className={viewingReport.penalty > 0 ? 'br-neg' : ''}>{fmtINR(viewingReport.penalty)}</b>{viewingReport.formula?.penalty && <span>{viewingReport.formula.penalty}</span>}</div>
              </div>

              {(viewingReport.cgst > 0 || viewingReport.sgst > 0 || viewingReport.igst > 0) && (
                <>
                  <div className="prm-section-title">Tax summary</div>
                  <div className="br-detail-grid">
                    {viewingReport.cgst > 0 && <div><small>CGST</small><b>{fmtINR(viewingReport.cgst)}</b></div>}
                    {viewingReport.sgst > 0 && <div><small>SGST</small><b>{fmtINR(viewingReport.sgst)}</b></div>}
                    {viewingReport.igst > 0 && <div><small>IGST</small><b>{fmtINR(viewingReport.igst)}</b></div>}
                    {viewingReport.formula?.gst && <div style={{ gridColumn: '1 / -1' }}><small>{viewingReport.formula.gst}</small></div>}
                  </div>
                </>
              )}

              <div className="prm-section-title">Refund</div>
              <div className="br-detail-grid">
                <div><small>Refund to Customer</small><b className={viewingReport.refund > 0 ? 'br-neg' : ''}>{fmtINR(viewingReport.refund)}</b></div>
              </div>

              <div className="br-total-block">
                <div><small>Payable Amount</small><b className="br-total">{fmtINR(viewingReport.payableAmount)}</b></div>
                {viewingReport.formula?.payable && <div className="br-formula">{viewingReport.formula.payable}</div>}
              </div>
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={closeViewModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DETAILS LOADING */}
      {viewingReport && isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusReport;